/**
 * @generated SignedSource<<dd3933e84310af98338eaa8515d0959f>>
 * @relayHash ab3e58a64805cb59626f46d745cd4345
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 45bd958f3dfa7010173033fddf83e52ca66aabcdcc961f749de9b05dd842a2b7

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventsScreenQuery$variables = Record<PropertyKey, never>;
export type EventsScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventsScreenList_query" | "SponsorsSection_query">;
};
export type EventsScreenQuery = {
  response: EventsScreenQuery$data;
  variables: EventsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "and": [
        {
          "not": {
            "metadata": {
              "containsKey": "meetupEventID"
            }
          }
        },
        {
          "allowGlobalListing": {
            "equalTo": true
          }
        }
      ]
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "timeSelection",
    "value": "UPCOMING"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slugId",
  "storageKey": null
},
v7 = {
  "kind": "Literal",
  "name": "dpr",
  "value": 3
},
v8 = {
  "kind": "Literal",
  "name": "fit",
  "value": "cover"
},
v9 = {
  "kind": "Literal",
  "name": "h",
  "value": 100
},
v10 = {
  "kind": "Literal",
  "name": "w",
  "value": 100
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "GuildMembership",
  "kind": "LinkedField",
  "name": "myMembership",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipLevel",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailMd5",
  "storageKey": null
},
v15 = {
  "kind": "Literal",
  "name": "fo",
  "value": "auto"
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "primaryPhoto",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            (v7/*: any*/),
            (v8/*: any*/),
            (v15/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/)
          ],
          "kind": "ObjectValue",
          "name": "transform"
        }
      ],
      "kind": "ScalarField",
      "name": "transformUrl",
      "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"fo\":\"auto\",\"h\":100,\"w\":100})"
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": [
    {
      "fields": [
        (v7/*: any*/),
        (v15/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/)
      ],
      "kind": "ObjectValue",
      "name": "transform"
    }
  ],
  "kind": "ScalarField",
  "name": "defaultAvatarUrl",
  "storageKey": "defaultAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":100,\"w\":100})"
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v5/*: any*/),
  (v14/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v3/*: any*/)
],
v21 = [
  (v19/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventsScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "EventsScreenList_query"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "SponsorsSection_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EventsScreenQuery",
    "selections": [
      {
        "alias": "upcomingEvents",
        "args": (v0/*: any*/),
        "concreteType": "EventsConnection",
        "kind": "LinkedField",
        "name": "eventsByTimeSelection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EventsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAt",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prettyUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasExternalUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasVenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visibility",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "coverPhoto",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": "mobileTransformUrl",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "transform",
                            "value": {
                              "dpr": 3,
                              "w": 576
                            }
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "transformUrl",
                        "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":576})"
                      },
                      {
                        "alias": "desktopTransformUrl",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "transform",
                            "value": {
                              "dpr": 3,
                              "w": 200
                            }
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "transformUrl",
                        "storageKey": "transformUrl(transform:{\"dpr\":3,\"w\":200})"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "eventOwner",
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "primaryPhoto",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "fields": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "transform"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "transformUrl",
                                "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"cover\",\"h\":100,\"w\":100})"
                              }
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          (v5/*: any*/)
                        ],
                        "type": "Guild",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isMe",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v14/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/)
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "attendeesByRelevance",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "status": {
                            "in": [
                              "ATTENDING_IN_PERSON",
                              "ATTENDING_VIRTUAL",
                              "WAITING_IN_PERSON",
                              "WAITING_VIRTUAL"
                            ]
                          }
                        }
                      },
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 8
                      }
                    ],
                    "concreteType": "EventAttendeesConnection",
                    "kind": "LinkedField",
                    "name": "eventAttendeesByRelevance",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendeesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventAttendee",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v20/*: any*/),
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "eventAttendeesByRelevance(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\",\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}},first:8)"
                  },
                  {
                    "alias": "attendingCount",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "status": {
                            "in": [
                              "ATTENDING_IN_PERSON",
                              "ATTENDING_VIRTUAL"
                            ]
                          }
                        }
                      }
                    ],
                    "concreteType": "EventAttendeesConnection",
                    "kind": "LinkedField",
                    "name": "eventAttendees",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"ATTENDING_IN_PERSON\",\"ATTENDING_VIRTUAL\"]}})"
                  },
                  {
                    "alias": "waitingCount",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "status": {
                            "in": [
                              "WAITING_IN_PERSON",
                              "WAITING_VIRTUAL"
                            ]
                          }
                        }
                      }
                    ],
                    "concreteType": "EventAttendeesConnection",
                    "kind": "LinkedField",
                    "name": "eventAttendees",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": "eventAttendees(filter:{\"status\":{\"in\":[\"WAITING_IN_PERSON\",\"WAITING_VIRTUAL\"]}})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventTicketingTiersConnection",
                    "kind": "LinkedField",
                    "name": "eventTicketingTiers",
                    "plural": false,
                    "selections": (v21/*: any*/),
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventAttendee",
                    "kind": "LinkedField",
                    "name": "myAttendance",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EventAttendeeTicketPurchase",
                        "kind": "LinkedField",
                        "name": "ticketPurchase",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "stripePaymentIntentStatus",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/),
                          (v11/*: any*/)
                        ],
                        "type": "Guild",
                        "abstractKey": null
                      },
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": "eventItemPresentations",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "CREATED_AT_ASC",
                          "ID_ASC"
                        ]
                      }
                    ],
                    "concreteType": "PresentationsConnection",
                    "kind": "LinkedField",
                    "name": "presentations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PresentationsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Presentation",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "presenterFirstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "presenterLastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "presenter",
                                "plural": false,
                                "selections": (v20/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "transform",
                                    "value": {
                                      "dpr": 3,
                                      "fo": "auto",
                                      "h": 24,
                                      "w": 24
                                    }
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "guestPresenterAvatarUrl",
                                "storageKey": "guestPresenterAvatarUrl(transform:{\"dpr\":3,\"fo\":\"auto\",\"h\":24,\"w\":24})"
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "presentations(orderBy:[\"CREATED_AT_ASC\",\"ID_ASC\"])"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "eventsByTimeSelection(filter:{\"and\":[{\"not\":{\"metadata\":{\"containsKey\":\"meetupEventID\"}}},{\"allowGlobalListing\":{\"equalTo\":true}}]},first:10,timeSelection:\"UPCOMING\")"
      },
      {
        "alias": "upcomingEvents",
        "args": (v0/*: any*/),
        "filters": [
          "timeSelection",
          "filter"
        ],
        "handle": "connection",
        "key": "EventsScreenList_query_upcomingEvents",
        "kind": "LinkedHandle",
        "name": "eventsByTimeSelection"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "authorizationLevel",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 2
          }
        ],
        "concreteType": "GuildSponsorshipsConnection",
        "kind": "LinkedField",
        "name": "sponsorships",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GuildSponsorshipsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GuildSponsorship",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "webUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linkText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "lightModeImage",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "transform",
                            "value": {
                              "dpr": 3,
                              "fit": "contain",
                              "fo": "left",
                              "h": 80,
                              "w": 150
                            }
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "transformUrl",
                        "storageKey": "transformUrl(transform:{\"dpr\":3,\"fit\":\"contain\",\"fo\":\"left\",\"h\":80,\"w\":150})"
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Guild",
                    "kind": "LinkedField",
                    "name": "guild",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "sponsorships(first:2)"
      }
    ]
  },
  "params": {
    "id": "45bd958f3dfa7010173033fddf83e52ca66aabcdcc961f749de9b05dd842a2b7",
    "metadata": {},
    "name": "EventsScreenQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "007fd619526fa187e7e7dc58d99cd8e4";

export default node;
